import React from 'react'
import Classes from './Home.module.css'
import useScreenWidth from '../../Hooks/useScreenWidth';
import { useNavigate } from 'react-router-dom';
const CartSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z" /></svg>
)
const PlaySvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z" /></svg>
)

export default function SectionA({ setopenCart }) {
  const isWidthLess600 = useScreenWidth() < 600;
  const navigateTo = useNavigate();

  return (
    <section className={`${Classes.sectionA} paddingAll`} >
      <div className={Classes.gridALeft} >
        <div>
          <h5 className={Classes.title1} > Replica? <br /> Real Vibes <br /> Only. </h5>
          <h5 className={Classes.text} >
            Top-tier sneakers from verified Vietnam manufacturers. <br /> Same style, same vibe—just way more affordable. Fast + free shipping, always.
          </h5>
          <div className={Classes.flexAlign10} >
            <button className={`${Classes.outlineBtn} flex10`} onClick={() => { isWidthLess600 ? navigateTo('/cart') : setopenCart(true) }} >
              <h5>Cart</h5>
              <CartSvg />
            </button>
            <button className={`${Classes.inlineBtn} flex10`} onClick={() => { navigateTo('/all-products') }} >
              <h5>Browse</h5>
              <PlaySvg />
            </button>
          </div>
          {/* <img src="/images/eclipse1.png" alt="" className={Classes.eclipse1} /> */}
        </div>
      </div>
      <div className={Classes.gridARight} >
        <div>
          <div className={Classes.sliderCon}>
            <div className={Classes.imageCon}>
              <img src='https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1748022844/demo_trtaoe.webp' alt='shoe1' rel="noopener noreferrer" draggable={false} />
            </div>
            {/* <img src="/images/eclipse1.png" alt="" className={Classes.eclipse2} /> */}
          </div>
        </div>
      </div>
    </section>
  )
}
